import React, { FunctionComponent } from 'react';

type ISLSFSwitch = {
  checked: boolean;
  onChange(value: boolean): void;
  offColor?: string;
};

const SLSFSwitch: FunctionComponent<ISLSFSwitch> = ({
  checked,
  onChange,
  offColor = '#EBEBEB',
}) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      style={{
        backgroundColor: offColor,
        position: 'relative',
        width: '110px',
        height: '54px',
        borderRadius: '27px',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        padding: 0,
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: '5px',
          left: checked ? 'calc(100% - 49px)' : '5px',
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          background: 'url("/imgs/logo.svg")',
          transition: 'left 0.2s, background-color 0.2s',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        }}
      />
    </button>
  );
};

export default SLSFSwitch;
